<template>
  <svg :style="cssVars" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 768">
    <g id="Done_-_Porch" data-name="Done - Porch">
      <rect class="porch-1" width="1024" height="377.32" />
      <rect class="porch-2" y="33.8" width="1024" height="2.98" />
      <rect class="porch-2" y="72.3" width="1024" height="2.98" />
      <rect class="porch-2" y="110.8" width="1024" height="2.98" />
      <rect class="porch-2" y="149.3" width="1024" height="2.98" />
      <rect class="porch-2" y="187.8" width="1024" height="2.98" />
      <rect class="porch-2" y="226.3" width="1024" height="2.98" />
      <rect class="porch-2" y="264.8" width="1024" height="2.98" />
      <rect class="porch-2" y="303.31" width="1024" height="2.98" />
      <rect class="porch-2" y="341.81" width="1024" height="2.98" />
      <rect class="porch-3" x="389.65" y="46.03" width="242.87" height="255.76" />
      <rect class="porch-4" x="413.58" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="464.8" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="515.88" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="567.09" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="413.58" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="413.58" y="185.25" width="194.06" height="90.68" />
      <rect class="porch-4" x="464.8" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="515.88" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="567.09" y="128.11" width="40.55" height="48.47" />
      <polygon
        class="porch-2"
        points="449.74 119.43 454.13 119.43 454.13 70.96 413.58 70.96 413.58 76.35 449.74 76.35 449.74 119.43"
      />
      <polygon
        class="porch-2"
        points="500.96 119.43 505.34 119.43 505.34 70.96 464.8 70.96 464.8 76.35 500.96 76.35 500.96 119.43"
      />
      <polygon
        class="porch-2"
        points="552.04 119.43 556.42 119.43 556.42 70.96 515.88 70.96 515.88 76.35 552.04 76.35 552.04 119.43"
      />
      <polygon
        class="porch-2"
        points="567.09 70.96 567.09 76.35 603.26 76.35 603.26 119.43 607.64 119.43 607.64 70.96 567.09 70.96"
      />
      <polygon
        class="porch-2"
        points="413.58 190.64 603.26 190.64 603.26 275.93 607.64 275.93 607.64 185.25 413.58 185.25 413.58 190.64"
      />
      <polygon
        class="porch-2"
        points="449.74 176.57 454.13 176.57 454.13 128.1 413.58 128.1 413.58 133.49 449.74 133.49 449.74 176.57"
      />
      <polygon
        class="porch-2"
        points="500.96 176.57 505.34 176.57 505.34 128.1 464.8 128.1 464.8 133.49 500.96 133.49 500.96 176.57"
      />
      <polygon
        class="porch-2"
        points="552.04 176.57 556.42 176.57 556.42 128.1 515.88 128.1 515.88 133.49 552.04 133.49 552.04 176.57"
      />
      <polygon
        class="porch-2"
        points="567.09 133.49 603.26 133.49 603.26 176.57 607.64 176.57 607.64 128.1 567.09 128.1 567.09 133.49"
      />
      <rect class="porch-3" x="51.25" y="46.03" width="242.87" height="255.76" />
      <rect class="porch-4" x="75.18" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="126.39" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="177.47" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="228.69" y="70.96" width="40.55" height="48.47" />
      <rect class="porch-4" x="75.18" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="75.18" y="185.25" width="194.06" height="90.68" />
      <rect class="porch-4" x="126.39" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="177.47" y="128.11" width="40.55" height="48.47" />
      <rect class="porch-4" x="228.69" y="128.11" width="40.55" height="48.47" />
      <polygon
        class="porch-2"
        points="75.18 190.64 264.86 190.64 264.86 275.93 269.24 275.93 269.24 185.25 75.18 185.25 75.18 190.64"
      />
      <polygon
        class="porch-2"
        points="111.34 119.43 115.72 119.43 115.72 70.96 75.18 70.96 75.18 76.35 111.34 76.35 111.34 119.43"
      />
      <polygon
        class="porch-2"
        points="162.56 119.43 166.94 119.43 166.94 70.96 126.39 70.96 126.39 76.35 162.56 76.35 162.56 119.43"
      />
      <polygon
        class="porch-2"
        points="213.64 119.43 218.02 119.43 218.02 70.96 177.47 70.96 177.47 76.35 213.64 76.35 213.64 119.43"
      />
      <polygon
        class="porch-2"
        points="228.69 70.96 228.69 76.35 264.86 76.35 264.86 119.43 269.24 119.43 269.24 70.96 228.69 70.96"
      />
      <polygon
        class="porch-2"
        points="111.34 176.57 115.72 176.57 115.72 128.1 75.18 128.1 75.18 133.49 111.34 133.49 111.34 176.57"
      />
      <polygon
        class="porch-2"
        points="162.56 176.57 166.94 176.57 166.94 128.1 126.39 128.1 126.39 133.49 162.56 133.49 162.56 176.57"
      />
      <polygon
        class="porch-2"
        points="213.64 176.57 218.02 176.57 218.02 128.1 177.47 128.1 177.47 133.49 213.64 133.49 213.64 176.57"
      />
      <polygon
        class="porch-2"
        points="228.69 133.49 264.86 133.49 264.86 176.57 269.24 176.57 269.24 128.1 228.69 128.1 228.69 133.49"
      />
      <rect class="porch-4" y="444.88" width="1024" height="96.34" />
      <rect class="porch-1" y="427.58" width="1024" height="17.29" />
      <path
        class="porch-2"
        d="M1024,490.37H933.38V452H1024v-7.15H0V452H102.5v38.34H0v5.35H46.76v45.49H52V495.72H160.56v45.49h5.22V495.72H289.52v45.49h5.22V495.72H403.32v45.49h5.22V495.72H515.88v45.49h5.21V495.72H629.67v45.49h5.22V495.72H758.63v45.49h5.22V495.72H872.43v45.49h5.22V495.72H984.32v45.49h5.21V495.72H1024Zm-807.7,0H107.72V452H216.3Zm129,0H221.51V452H345.25Zm113.8,0H350.47V452H459.05Zm112.56,0H464.27V452H571.61Zm113.8,0H576.83V452H685.41Zm129,0H690.63V452H814.37Zm113.79,0H819.58V452H928.16Z"
      />
      <rect class="porch-3" x="802.86" y="46.03" width="181.45" height="331.29" />
      <path class="porch-5" d="M619.85,288.42H402.31v-229H619.85Zm-214.61-3H616.92v-223H405.24Z" />
      <path class="porch-5" d="M281.45,288.42H63.91v-229H281.45Zm-214.61-3H278.52v-223H66.84Z" />
      <path class="porch-5" d="M976.12,367.84H811.31V54.67H976.12Zm-161.88-3h159V57.67h-159Z" />
      <rect class="porch-4" x="824.74" y="68.44" width="137.96" height="129.52" />
      <rect class="porch-4" x="824.74" y="220.65" width="137.96" height="129.52" />
      <polygon
        class="porch-2"
        points="958.32 197.97 962.7 197.97 962.7 68.44 824.74 68.44 824.74 73.83 958.32 73.83 958.32 197.97"
      />
      <polygon
        class="porch-2"
        points="958.32 350.18 962.7 350.18 962.7 220.65 824.74 220.65 824.74 226.04 958.32 226.04 958.32 350.18"
      />
      <rect class="porch-6" x="966.59" y="197.97" width="3" height="22.69" />
      <rect class="porch-7" y="541.21" width="1024" height="226.79" />
      <polygon
        class="porch-3"
        points="695.14 768 634.25 566.07 380.3 566.07 319.42 768 695.14 768"
      />
      <polygon
        class="porch-1"
        points="635.25 569.38 634.25 566.07 380.3 566.07 379.31 569.38 635.25 569.38"
      />
      <polygon
        class="porch-1"
        points="664.6 665.4 663.09 661.72 351.47 661.72 349.96 665.4 664.6 665.4"
      />
      <rect class="porch-8" x="788.01" y="227.94" width="235.99" height="14.3" />
      <rect
        class="porch-8"
        x="749.09"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1109.41 -506.85) rotate(90)"
      />
      <rect
        class="porch-8"
        x="784.15"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1144.48 -541.91) rotate(90)"
      />
      <rect
        class="porch-8"
        x="819.22"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1179.54 -576.98) rotate(90)"
      />
      <rect
        class="porch-8"
        x="854.28"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1214.6 -612.04) rotate(90)"
      />
      <rect
        class="porch-8"
        x="889.34"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1249.67 -647.1) rotate(90)"
      />
      <rect
        class="porch-8"
        x="924.41"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(1284.73 -682.17) rotate(90)"
      />
      <rect class="porch-8" x="1011.53" y="242.24" width="12.47" height="118.08" />
      <rect
        class="porch-5"
        x="806.7"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1167.02 -449.24) rotate(90)"
      />
      <rect
        class="porch-5"
        x="841.76"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1202.09 -484.31) rotate(90)"
      />
      <rect
        class="porch-5"
        x="876.83"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1237.15 -519.37) rotate(90)"
      />
      <rect
        class="porch-5"
        x="911.89"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1272.21 -554.43) rotate(90)"
      />
      <rect
        class="porch-5"
        x="946.95"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1307.28 -589.5) rotate(90)"
      />
      <rect
        class="porch-5"
        x="982.02"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(1342.34 -624.56) rotate(90)"
      />
      <rect class="porch-5" x="1011.54" y="357.46" width="12.46" height="2.87" />
      <rect
        class="porch-5"
        x="806.33"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1052.17 -564.09) rotate(90)"
      />
      <rect
        class="porch-5"
        x="841.4"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1087.24 -599.16) rotate(90)"
      />
      <rect
        class="porch-5"
        x="876.46"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1122.3 -634.22) rotate(90)"
      />
      <rect
        class="porch-5"
        x="911.52"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1157.36 -669.28) rotate(90)"
      />
      <rect
        class="porch-5"
        x="946.59"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1192.43 -704.35) rotate(90)"
      />
      <rect
        class="porch-5"
        x="981.65"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(1227.49 -739.41) rotate(90)"
      />
      <rect class="porch-5" x="1011.54" y="242.24" width="12.46" height="3.6" />
      <rect class="porch-8" x="788.01" y="360.32" width="235.99" height="18.35" />
      <rect class="porch-8" y="227.94" width="184.35" height="14.3" />
      <rect
        class="porch-8"
        x="-32.91"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(327.41 275.15) rotate(90)"
      />
      <rect
        class="porch-8"
        x="2.15"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(362.47 240.09) rotate(90)"
      />
      <rect
        class="porch-8"
        x="37.21"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(397.54 205.03) rotate(90)"
      />
      <rect
        class="porch-8"
        x="72.28"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(432.6 169.96) rotate(90)"
      />
      <rect
        class="porch-8"
        x="107.34"
        y="294.3"
        width="118.08"
        height="13.96"
        transform="translate(467.66 134.9) rotate(90)"
      />
      <rect
        class="porch-5"
        x="24.7"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(385.02 332.76) rotate(90)"
      />
      <rect
        class="porch-5"
        x="59.76"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(420.08 297.7) rotate(90)"
      />
      <rect
        class="porch-5"
        x="94.82"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(455.15 262.64) rotate(90)"
      />
      <rect
        class="porch-5"
        x="129.89"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(490.21 227.57) rotate(90)"
      />
      <rect
        class="porch-5"
        x="164.95"
        y="351.91"
        width="2.87"
        height="13.96"
        transform="translate(525.27 192.51) rotate(90)"
      />
      <rect
        class="porch-5"
        x="24.33"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(270.17 217.91) rotate(90)"
      />
      <rect
        class="porch-5"
        x="59.39"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(305.23 182.85) rotate(90)"
      />
      <rect
        class="porch-5"
        x="94.46"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(340.3 147.78) rotate(90)"
      />
      <rect
        class="porch-5"
        x="129.52"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(375.36 112.72) rotate(90)"
      />
      <rect
        class="porch-5"
        x="164.58"
        y="237.06"
        width="3.6"
        height="13.96"
        transform="translate(410.42 77.66) rotate(90)"
      />
      <rect class="porch-8" y="360.32" width="184.35" height="18.35" />
      <rect class="porch-7" x="705.16" y="222.73" width="88.4" height="9.34" />
      <rect class="porch-7" x="705.16" y="367.98" width="88.4" height="9.34" />
      <rect class="porch-7" x="715.68" y="232.07" width="70.16" height="135.9" />
      <rect class="porch-1" x="715.7" y="232.07" width="70.11" height="4.67" />
      <rect class="porch-1" x="715.7" y="363.31" width="70.11" height="4.67" />
      <polygon class="porch-8" points="723.29 0 715.7 222.73 785.82 222.73 778.23 0 723.29 0" />
      <rect class="porch-7" x="173.82" y="222.73" width="88.4" height="9.34" />
      <rect class="porch-7" x="173.82" y="367.98" width="88.4" height="9.34" />
      <rect class="porch-7" x="184.35" y="232.07" width="70.16" height="135.9" />
      <rect class="porch-1" x="184.37" y="232.07" width="70.11" height="4.67" />
      <rect class="porch-1" x="184.37" y="363.31" width="70.11" height="4.67" />
      <polygon class="porch-8" points="191.96 0 184.37 222.73 254.49 222.73 246.9 0 191.96 0" />
      <path
        class="porch-6"
        d="M843,660c-2.86-2.21-4.44-15.65-4.44-15.65-.77,5.42,1.61,14.36,2,15.65Z"
      />
      <path
        class="porch-6"
        d="M838.75,660c.71-.1,1.54-.24,1.3-.31-2.7-.79-6.25-12.23-6.25-12.23.2,4.59,3.54,11.59,4,12.54Z"
      />
      <path
        class="porch-6"
        d="M836,660c.39-.14,1.11-.41.93-.42-1.61-.14-5-6.36-5-6.36.68,2.61,3.37,6.21,3.81,6.78Z"
      />
      <path class="porch-6" d="M845.77,660c.23-1.37.76-5.08.26-7.38,0,0-.19,5.39-1.14,7.38Z" />
      <path class="porch-6" d="M848,660c.58-1.48,2.19-5.83,2.17-8.73,0,0-1.76,7.09-3.47,8.73Z" />
      <path
        class="porch-6"
        d="M292.77,745.24c2.86-2.21,4.44-15.65,4.44-15.65.77,5.41-1.61,14.36-2,15.65Z"
      />
      <path
        class="porch-6"
        d="M297,745.24c-.71-.1-1.54-.24-1.3-.31,2.7-.79,6.24-12.23,6.24-12.23-.19,4.59-3.53,11.58-4,12.54Z"
      />
      <path
        class="porch-6"
        d="M299.77,745.24c-.39-.14-1.11-.41-.93-.43,1.61-.13,5.05-6.36,5.05-6.36-.68,2.61-3.37,6.22-3.81,6.79Z"
      />
      <path class="porch-6" d="M290,745.24c-.23-1.38-.76-5.09-.26-7.39,0,0,.19,5.39,1.14,7.39Z" />
      <path
        class="porch-6"
        d="M287.76,745.24c-.58-1.48-2.19-5.83-2.18-8.73,0,0,1.77,7.08,3.48,8.73Z"
      />
      <path
        class="porch-6"
        d="M77.8,646.56c-4.56-2.21-7.09-15.65-7.09-15.65-1.24,5.41,2.57,14.36,3.14,15.65Z"
      />
      <path
        class="porch-6"
        d="M71,646.56c1.13-.1,2.47-.24,2.08-.31-4.3-.79-10-12.23-10-12.23.31,4.58,5.65,11.58,6.39,12.54Z"
      />
      <path
        class="porch-6"
        d="M66.62,646.56c.62-.14,1.77-.41,1.49-.43C65.53,646,60,639.77,60,639.77c1.09,2.61,5.4,6.22,6.09,6.79Z"
      />
      <path class="porch-6" d="M82.25,646.56c.36-1.38,1.2-5.09.41-7.39,0,0-.31,5.39-1.83,7.39Z" />
      <path class="porch-6" d="M85.8,646.56c.93-1.48,3.5-5.83,3.48-8.74,0,0-2.82,7.09-5.55,8.74Z" />
      <path
        class="porch-6"
        d="M257,615.71c-3.52-2.21-5.48-15.65-5.48-15.65-1,5.42,2,14.36,2.43,15.65Z"
      />
      <path
        class="porch-6"
        d="M258.71,615.71c2.83-1.77,4.4-12.54,4.4-12.54.77,4.34-1.6,11.51-1.95,12.54Z"
      />
      <path
        class="porch-6"
        d="M261.5,615.71c4.47-.89,6.95-6.27,6.95-6.27,1.21,2.17-2.52,5.75-3.08,6.27Z"
      />
      <path
        class="porch-6"
        d="M251.72,615.71c.88-.1,1.91-.24,1.61-.31-3.33-.79-7.72-12.23-7.72-12.23.25,4.59,4.37,11.59,4.95,12.54Z"
      />
      <path
        class="porch-6"
        d="M248.44,615.75c-2.3-2.1-4.94-6.77-4.94-6.77.47,2.26,2.25,5,3.55,6.77Z"
      />
      <path
        class="porch-6"
        d="M244,615.64h1.39a41.94,41.94,0,0,1-5.11-4.48A16.85,16.85,0,0,0,244,615.64Z"
      />
      <path class="porch-6" d="M258.15,615.71c.33-1.38,1.09-5.09.37-7.39,0,0-.28,5.39-1.65,7.39Z" />
      <path
        class="porch-6"
        d="M989.4,737.39c-3.53-2.21-5.48-15.65-5.48-15.65-1,5.42,2,14.36,2.43,15.65Z"
      />
      <path
        class="porch-6"
        d="M991.14,737.39c2.84-1.77,4.41-12.54,4.41-12.54.77,4.34-1.6,11.51-1.95,12.54Z"
      />
      <path
        class="porch-6"
        d="M993.94,737.39c4.47-.88,6.95-6.27,6.95-6.27,1.21,2.17-2.52,5.76-3.08,6.27Z"
      />
      <path
        class="porch-6"
        d="M984.16,737.39c.87-.1,1.91-.24,1.61-.31-3.33-.79-7.72-12.23-7.72-12.23.24,4.59,4.37,11.59,5,12.54Z"
      />
      <path
        class="porch-6"
        d="M980.88,737.43c-2.31-2.1-4.94-6.77-4.94-6.77.47,2.26,2.25,5,3.55,6.77Z"
      />
      <path
        class="porch-6"
        d="M976.44,737.32h1.39a41.94,41.94,0,0,1-5.11-4.48A16.85,16.85,0,0,0,976.44,737.32Z"
      />
      <path class="porch-6" d="M990.59,737.39c.32-1.38,1.08-5.08.37-7.39,0,0-.28,5.39-1.65,7.39Z" />
      <path
        class="porch-6"
        d="M40.12,544.66h65.64a15.58,15.58,0,0,0,2.26-2,4,4,0,0,1,5.4-.95,33.25,33.25,0,0,0,8,2.95h13.52a36.8,36.8,0,0,0,5.73-1.74,4.48,4.48,0,0,1,5.75,1.45c.08.1.19.19.28.29h28.75c.38-.37.76-.74,1.13-1.13,1.28-1.33,2.72-1.95,4.52-1.14a7.74,7.74,0,0,0,4.42.47c7-1,13.93-1.83,21-1.49a11.54,11.54,0,0,0,3-.23,4.24,4.24,0,0,0,3.67-4.19,4.33,4.33,0,0,0-3.88-4.54,12,12,0,0,0-3-.18c-3.1.19-5.19-1-5.79-4.25a6.14,6.14,0,0,0-.27-1c-1.61-4.19-4.56-6.64-9-7a23.85,23.85,0,0,0-8,.45,6.54,6.54,0,0,1-7.22-2.23,18.45,18.45,0,0,0-10.85-5.93c-.49-.09-1-.28-1.47-.34-2.36-.3-3.54-1.66-3.69-4.05a11.48,11.48,0,0,0-.39-2,31,31,0,0,0-38.08-22.83,31.35,31.35,0,0,0-14.57,8.62c-3.45,3.44-3.45,3.35-7.59,1.16a26.72,26.72,0,0,0-12.45-3.53c-12.94-.09-25.08,10.69-21.66,26.38.25,1.15.38,2.34.55,3.52A2.22,2.22,0,0,1,64.12,522a17.45,17.45,0,0,1-2.41.71A11.29,11.29,0,0,0,53.05,529a5.34,5.34,0,0,1-4.71,3.27,9.41,9.41,0,0,0-2.46.48c-5,1.68-7.52,6.48-6,11.21C39.93,544.19,40,544.42,40.12,544.66Z"
      />
      <path
        class="porch-6"
        d="M103,545.86a10.41,10.41,0,0,0,2.61.19,98.93,98.93,0,0,1,18.27,1.3,6.74,6.74,0,0,0,3.85-.41c1.57-.7,2.81-.16,3.93,1a1.59,1.59,0,0,1,.13.13h26.69a3.8,3.8,0,0,1,4.43-.67c.66.26,1.31.46,2,.67h17.66a30.2,30.2,0,0,0,4.07-1.72,3.51,3.51,0,0,1,4.7.82c.3.33.61.61.92.9h58.46a7.75,7.75,0,0,0-5.3-9.54,8.22,8.22,0,0,0-2.14-.43,4.61,4.61,0,0,1-4.1-2.84,9.79,9.79,0,0,0-7.53-5.43,16.87,16.87,0,0,1-2.1-.62,1.94,1.94,0,0,1-1.43-2.38c.15-1,.26-2.06.48-3.07,3-13.65-7.59-23-18.85-23a23.36,23.36,0,0,0-10.84,3.08c-3.6,1.9-3.6,2-6.6-1a27,27,0,0,0-45.82,12.37,9.45,9.45,0,0,0-.34,1.73,3.35,3.35,0,0,1-3.22,3.52c-.43.06-.84.22-1.27.3a16.06,16.06,0,0,0-9.45,5.16,5.69,5.69,0,0,1-6.28,1.94,20.87,20.87,0,0,0-7-.39c-3.88.27-6.45,2.41-7.85,6a4.37,4.37,0,0,0-.23.86c-.53,2.86-2.35,3.86-5,3.7a10.36,10.36,0,0,0-2.61.15,3.77,3.77,0,0,0-3.38,4A3.71,3.71,0,0,0,103,545.86Z"
      />
      <path
        class="porch-6"
        d="M109,540.5a7.49,7.49,0,0,0-1.82-.33,3.93,3.93,0,0,1-3.49-2.25,8.37,8.37,0,0,0-6.43-4.31,16.21,16.21,0,0,1-1.78-.49,1.53,1.53,0,0,1-1.22-1.89c.13-.81.22-1.63.41-2.43,2.54-10.82-6.46-18.25-16.06-18.2A21,21,0,0,0,69.41,513c-3.08,1.51-3.08,1.57-5.63-.8A23.76,23.76,0,0,0,53,506.29c-12.92-3-25.2,4.24-28.23,15.75a7.54,7.54,0,0,0-.29,1.38,2.74,2.74,0,0,1-2.74,2.79c-.37,0-.72.17-1.09.24a14,14,0,0,0-8,4.08,5.09,5.09,0,0,1-5.36,1.55,18.74,18.74,0,0,0-5.93-.31,8.73,8.73,0,0,0-1.29.17v14.91q2.76.28,5.51.65a6.29,6.29,0,0,0,3.28-.32,2.87,2.87,0,0,1,3.35.78l.11.11H35a3.43,3.43,0,0,1,3.78-.53c.55.2,1.11.36,1.66.53h15A28.62,28.62,0,0,0,59,546.71a3.13,3.13,0,0,1,4,.65c.26.26.52.48.79.71h49.8C114.53,544.86,112.65,541.64,109,540.5Z"
      />
      <path
        class="porch-5"
        d="M97.75,485.53s-4.86,3.89,0,8.86C97.75,494.39,102.74,490.64,97.75,485.53Z"
      />
      <path class="porch-5" d="M97.75,497s-4.86,3.88,0,8.86C97.75,505.9,102.74,502.15,97.75,497Z" />
      <path
        class="porch-5"
        d="M87.84,495.75s3.79,5,8.64,0C96.48,495.75,92.83,490.64,87.84,495.75Z"
      />
      <path
        class="porch-5"
        d="M99.07,495.75s3.79,5,8.65,0C107.72,495.75,104.06,490.64,99.07,495.75Z"
      />
      <path
        class="porch-3"
        d="M90.73,488.54s-.76,6.26,6.11,6.26C96.84,494.8,97.78,488.54,90.73,488.54Z"
      />
      <path
        class="porch-3"
        d="M98.67,496.67s-.76,6.27,6.11,6.27C104.78,502.94,105.72,496.67,98.67,496.67Z"
      />
      <path
        class="porch-3"
        d="M90.77,502.94s6.11.78,6.11-6.27C96.88,496.67,90.77,495.71,90.77,502.94Z"
      />
      <path
        class="porch-3"
        d="M98.71,494.8s6.12.78,6.12-6.26C104.83,488.54,98.71,487.57,98.71,494.8Z"
      />
      <ellipse class="porch-8" cx="97.78" cy="495.8" rx="2.59" ry="2.66" />
      <path
        class="porch-5"
        d="M214.4,497.57s-5.17,1.28-3.09,7C211.31,504.54,216.54,503.42,214.4,497.57Z"
      />
      <path
        class="porch-5"
        d="M210.39,506.62s-5.18,1.28-3.1,7C207.29,513.59,212.53,512.47,210.39,506.62Z"
      />
      <path class="porch-5" d="M203,502s1.25,5.3,6.8,3.16C209.84,505.14,208.75,499.78,203,502Z" />
      <path
        class="porch-5"
        d="M211.88,506.09s1.24,5.3,6.8,3.17C218.68,509.26,217.58,503.9,211.88,506.09Z"
      />
      <path
        class="porch-3"
        d="M207.83,497.37s-2.78,4.65,2.63,7.16C210.46,504.53,213.38,500,207.83,497.37Z"
      />
      <path
        class="porch-3"
        d="M211.24,506.67s-2.78,4.65,2.62,7.17C213.86,513.84,216.79,509.26,211.24,506.67Z"
      />
      <path
        class="porch-3"
        d="M202.84,508.71s4.54,2.85,7-2.69C209.83,506,205.36,503,202.84,508.71Z"
      />
      <path
        class="porch-3"
        d="M211.92,505.22s4.54,2.85,7-2.69C218.92,502.53,214.45,499.53,211.92,505.22Z"
      />
      <ellipse class="porch-8" cx="210.84" cy="505.66" rx="2.24" ry="2.29" />
      <path
        class="porch-5"
        d="M37.31,502.51s-4.75,1.17-2.84,6.39C34.47,508.9,39.27,507.87,37.31,502.51Z"
      />
      <path
        class="porch-5"
        d="M33.62,510.81s-4.75,1.17-2.84,6.39C30.78,517.2,35.58,516.18,33.62,510.81Z"
      />
      <path
        class="porch-5"
        d="M26.88,506.55s1.14,4.86,6.24,2.9C33.12,509.45,32.12,504.53,26.88,506.55Z"
      />
      <path
        class="porch-5"
        d="M35,510.32s1.14,4.87,6.24,2.91C41.23,513.23,40.22,508.31,35,510.32Z"
      />
      <path
        class="porch-3"
        d="M31.28,502.31s-2.55,4.27,2.4,6.58C33.68,508.89,36.37,504.69,31.28,502.31Z"
      />
      <path
        class="porch-3"
        d="M34.4,510.86s-2.55,4.26,2.41,6.57C36.81,517.43,39.49,513.23,34.4,510.86Z"
      />
      <path
        class="porch-3"
        d="M26.7,512.72s4.16,2.62,6.41-2.46C33.11,510.26,29,507.51,26.7,512.72Z"
      />
      <path
        class="porch-3"
        d="M35,509.52s4.17,2.61,6.42-2.47C41.45,507.05,37.35,504.3,35,509.52Z"
      />
      <ellipse class="porch-8" cx="34.04" cy="509.92" rx="2.05" ry="2.1" />
      <path
        class="porch-5"
        d="M123.09,521.74s-4.75,1.17-2.84,6.4C120.25,528.14,125.05,527.11,123.09,521.74Z"
      />
      <path
        class="porch-5"
        d="M119.41,530.05s-4.75,1.16-2.84,6.39C116.57,536.44,121.37,535.41,119.41,530.05Z"
      />
      <path
        class="porch-5"
        d="M112.67,525.78s1.14,4.87,6.24,2.91C118.91,528.69,117.9,523.77,112.67,525.78Z"
      />
      <path
        class="porch-5"
        d="M120.77,529.56s1.14,4.86,6.24,2.9C127,532.46,126,527.54,120.77,529.56Z"
      />
      <path
        class="porch-3"
        d="M117.06,521.55s-2.55,4.27,2.41,6.58C119.47,528.13,122.15,523.92,117.06,521.55Z"
      />
      <path
        class="porch-3"
        d="M120.19,530.09s-2.55,4.27,2.4,6.58C122.59,536.67,125.28,532.46,120.19,530.09Z"
      />
      <path
        class="porch-3"
        d="M112.48,532s4.17,2.61,6.42-2.47C118.9,529.49,114.79,526.74,112.48,532Z"
      />
      <path
        class="porch-3"
        d="M120.82,528.75s4.16,2.62,6.41-2.46C127.23,526.29,123.13,523.54,120.82,528.75Z"
      />
      <ellipse class="porch-8" cx="119.82" cy="529.16" rx="2.05" ry="2.1" />
      <path
        class="porch-5"
        d="M81.92,508.62s-3.42.84-2,4.61C79.88,513.23,83.34,512.49,81.92,508.62Z"
      />
      <path
        class="porch-5"
        d="M79.27,514.61s-3.43.85-2,4.62C77.22,519.23,80.68,518.49,79.27,514.61Z"
      />
      <path class="porch-5" d="M74.4,511.54a3.11,3.11,0,0,0,4.51,2.09S78.18,510.08,74.4,511.54Z" />
      <path class="porch-5" d="M80.25,514.26a3.12,3.12,0,0,0,4.51,2.1S84,512.81,80.25,514.26Z" />
      <path
        class="porch-3"
        d="M77.57,508.48a3.23,3.23,0,0,0,1.74,4.75S81.25,510.19,77.57,508.48Z"
      />
      <path
        class="porch-3"
        d="M79.83,514.65a3.22,3.22,0,0,0,1.74,4.74S83.51,516.36,79.83,514.65Z"
      />
      <path class="porch-3" d="M74.27,516s3,1.89,4.63-1.78C78.9,514.21,75.94,512.23,74.27,516Z" />
      <path
        class="porch-3"
        d="M80.28,513.68s3,1.89,4.64-1.78C84.92,511.9,82,509.92,80.28,513.68Z"
      />
      <ellipse class="porch-8" cx="79.57" cy="513.97" rx="1.48" ry="1.52" />
      <path class="porch-5" d="M51.8,528.6s-2.79.69-1.67,3.76C50.13,532.36,53,531.75,51.8,528.6Z" />
      <path
        class="porch-5"
        d="M49.63,533.48s-2.79.68-1.66,3.75C48,537.23,50.79,536.63,49.63,533.48Z"
      />
      <path class="porch-5" d="M45.67,531a2.54,2.54,0,0,0,3.67,1.71S48.75,529.79,45.67,531Z" />
      <path class="porch-5" d="M50.44,533.19a2.53,2.53,0,0,0,3.66,1.71S53.51,532,50.44,533.19Z" />
      <path
        class="porch-3"
        d="M48.26,528.49a2.62,2.62,0,0,0,1.41,3.86S51.25,529.88,48.26,528.49Z"
      />
      <path class="porch-3" d="M50.09,533.5a2.63,2.63,0,0,0,1.42,3.87S53.08,534.9,50.09,533.5Z" />
      <path
        class="porch-3"
        d="M45.56,534.6s2.45,1.54,3.77-1.45C49.33,533.15,46.92,531.54,45.56,534.6Z"
      />
      <path
        class="porch-3"
        d="M50.46,532.72s2.45,1.53,3.77-1.45C54.23,531.27,51.82,529.65,50.46,532.72Z"
      />
      <ellipse class="porch-8" cx="49.88" cy="532.96" rx="1.21" ry="1.24" />
      <path
        class="porch-5"
        d="M193.27,528.6s-2.79.69-1.67,3.76C191.6,532.36,194.42,531.75,193.27,528.6Z"
      />
      <path
        class="porch-5"
        d="M191.11,533.48s-2.79.68-1.67,3.75C189.44,537.23,192.26,536.63,191.11,533.48Z"
      />
      <path class="porch-5" d="M187.15,531a2.53,2.53,0,0,0,3.66,1.71S190.22,529.79,187.15,531Z" />
      <path class="porch-5" d="M191.91,533.19a2.54,2.54,0,0,0,3.67,1.71S195,532,191.91,533.19Z" />
      <path
        class="porch-3"
        d="M189.73,528.49a2.62,2.62,0,0,0,1.41,3.86S192.72,529.88,189.73,528.49Z"
      />
      <path
        class="porch-3"
        d="M191.57,533.5a2.63,2.63,0,0,0,1.41,3.87S194.56,534.9,191.57,533.5Z"
      />
      <path
        class="porch-3"
        d="M187,534.6s2.45,1.54,3.77-1.45C190.81,533.15,188.4,531.54,187,534.6Z"
      />
      <path
        class="porch-3"
        d="M191.94,532.72s2.44,1.53,3.77-1.45C195.71,531.27,193.3,529.65,191.94,532.72Z"
      />
      <ellipse class="porch-8" cx="191.35" cy="532.96" rx="1.21" ry="1.24" />
      <path
        class="porch-5"
        d="M150.54,485.64s-2.79.68-1.66,3.75C148.88,489.39,151.69,488.79,150.54,485.64Z"
      />
      <path
        class="porch-5"
        d="M148.38,490.51s-2.79.69-1.67,3.76C146.71,494.27,149.53,493.67,148.38,490.51Z"
      />
      <path class="porch-5" d="M144.42,488a2.54,2.54,0,0,0,3.67,1.71S147.5,486.83,144.42,488Z" />
      <path class="porch-5" d="M149.18,490.23a2.53,2.53,0,0,0,3.67,1.7S152.26,489,149.18,490.23Z" />
      <path class="porch-3" d="M147,485.52a2.63,2.63,0,0,0,1.41,3.87S150,486.92,147,485.52Z" />
      <path
        class="porch-3"
        d="M148.84,490.54a2.62,2.62,0,0,0,1.41,3.86S151.83,491.93,148.84,490.54Z"
      />
      <path
        class="porch-3"
        d="M144.31,491.64s2.45,1.53,3.77-1.45C148.08,490.19,145.67,488.57,144.31,491.64Z"
      />
      <path
        class="porch-3"
        d="M149.21,489.76s2.44,1.53,3.77-1.45C153,488.31,150.57,486.69,149.21,489.76Z"
      />
      <ellipse class="porch-8" cx="148.62" cy="489.99" rx="1.21" ry="1.24" />
      <path
        class="porch-5"
        d="M161.76,508.62s-3.43.84-2,4.61C159.71,513.23,163.17,512.49,161.76,508.62Z"
      />
      <path
        class="porch-5"
        d="M159.1,514.61s-3.43.85-2,4.62C157.05,519.23,160.52,518.49,159.1,514.61Z"
      />
      <path
        class="porch-5"
        d="M154.23,511.54a3.11,3.11,0,0,0,4.51,2.09S158,510.08,154.23,511.54Z"
      />
      <path
        class="porch-5"
        d="M160.09,514.26a3.11,3.11,0,0,0,4.5,2.1S163.86,512.81,160.09,514.26Z"
      />
      <path
        class="porch-3"
        d="M157.41,508.48a3.23,3.23,0,0,0,1.73,4.75S161.08,510.19,157.41,508.48Z"
      />
      <path
        class="porch-3"
        d="M159.66,514.65a3.22,3.22,0,0,0,1.74,4.74S163.34,516.36,159.66,514.65Z"
      />
      <path
        class="porch-3"
        d="M154.1,516s3,1.89,4.63-1.78C158.73,514.21,155.77,512.23,154.1,516Z"
      />
      <path
        class="porch-3"
        d="M160.12,513.68s3,1.89,4.63-1.78C164.75,511.9,161.79,509.92,160.12,513.68Z"
      />
      <ellipse class="porch-8" cx="159.4" cy="513.97" rx="1.48" ry="1.52" />
      <path
        class="porch-6"
        d="M980.73,544.59h-67a15.16,15.16,0,0,1-2.31-2.05,4.11,4.11,0,0,0-5.51-1,33.74,33.74,0,0,1-8.13,3H884a37.93,37.93,0,0,1-5.85-1.78,4.57,4.57,0,0,0-5.86,1.48c-.09.11-.2.2-.3.3H842.61c-.39-.38-.78-.76-1.16-1.15-1.3-1.36-2.77-2-4.61-1.17a8,8,0,0,1-4.51.48c-7.11-1-14.23-1.86-21.43-1.52a12.05,12.05,0,0,1-3.06-.23,4.34,4.34,0,0,1-3.74-4.29c-.07-2.39,1.36-4.13,4-4.63a12,12,0,0,1,3.06-.18c3.17.19,5.31-1,5.92-4.34a5.68,5.68,0,0,1,.27-1c1.65-4.27,4.66-6.78,9.21-7.09a24.07,24.07,0,0,1,8.16.46,6.7,6.7,0,0,0,7.38-2.28,18.79,18.79,0,0,1,11.07-6c.51-.1,1-.29,1.5-.35,2.41-.3,3.62-1.69,3.77-4.13a11.87,11.87,0,0,1,.4-2,31.69,31.69,0,0,1,38.87-23.31,32,32,0,0,1,14.87,8.8c3.53,3.52,3.52,3.42,7.76,1.19a27.28,27.28,0,0,1,12.7-3.61c13.22-.08,25.61,10.92,22.12,26.93-.26,1.18-.39,2.39-.57,3.6a2.27,2.27,0,0,0,1.68,2.79,21,21,0,0,0,2.46.73,11.52,11.52,0,0,1,8.84,6.37,5.44,5.44,0,0,0,4.81,3.34,9.72,9.72,0,0,1,2.5.49c5.07,1.72,7.69,6.61,6.16,11.45C980.92,544.1,980.83,544.35,980.73,544.59Z"
      />
      <path
        class="porch-6"
        d="M916.52,545.81a10.74,10.74,0,0,1-2.66.2,99.59,99.59,0,0,0-18.65,1.33,7,7,0,0,1-3.92-.42c-1.61-.72-2.88-.17-4,1l-.13.14H859.89a3.88,3.88,0,0,0-4.53-.68c-.66.26-1.33.46-2,.68h-18a31.48,31.48,0,0,1-4.16-1.75,3.56,3.56,0,0,0-4.79.84c-.31.33-.63.62-.94.91H765.77a7.91,7.91,0,0,1,5.41-9.74,8.18,8.18,0,0,1,2.18-.43,4.74,4.74,0,0,0,4.19-2.91,10,10,0,0,1,7.69-5.54,18.1,18.1,0,0,0,2.14-.64,2,2,0,0,0,1.46-2.43c-.15-1-.27-2.1-.49-3.13-3-13.93,7.74-23.51,19.24-23.43A23.86,23.86,0,0,1,818.65,503c3.69,1.95,3.68,2,6.75-1a27.56,27.56,0,0,1,46.77,12.63,10.08,10.08,0,0,1,.35,1.77,3.42,3.42,0,0,0,3.28,3.6c.44.05.87.22,1.31.3a16.37,16.37,0,0,1,9.63,5.27,5.83,5.83,0,0,0,6.42,2,21.2,21.2,0,0,1,7.1-.4c4,.28,6.59,2.46,8,6.17a5.35,5.35,0,0,1,.24.87c.53,2.93,2.39,3.95,5.15,3.78a10.4,10.4,0,0,1,2.67.16,3.84,3.84,0,0,1,3.44,4A3.78,3.78,0,0,1,916.52,545.81Z"
      />
      <path
        class="porch-6"
        d="M1024,532.48a8.05,8.05,0,0,0-3.63-1.05,19.5,19.5,0,0,0-6,.31,5.17,5.17,0,0,1-5.47-1.57,14.27,14.27,0,0,0-8.21-4.17c-.38-.07-.74-.2-1.11-.25a2.79,2.79,0,0,1-2.8-2.84,6.81,6.81,0,0,0-.3-1.41c-3.09-11.75-15.63-19.16-28.82-16.08a24.18,24.18,0,0,0-11,6.07c-2.61,2.43-2.61,2.36-5.75.82a21.45,21.45,0,0,0-9.42-2.49c-9.8-.06-19,7.54-16.4,18.58.19.81.29,1.65.42,2.48a1.57,1.57,0,0,1-1.24,1.93,17.11,17.11,0,0,1-1.83.5,8.52,8.52,0,0,0-6.55,4.39,4,4,0,0,1-3.57,2.31,7.35,7.35,0,0,0-1.86.34c-3.69,1.16-5.61,4.44-4.61,7.72h50.85c.27-.23.54-.46.8-.72a3.2,3.2,0,0,1,4.09-.67,26.74,26.74,0,0,0,3.54,1.39h15.36c.57-.17,1.13-.33,1.7-.54a3.48,3.48,0,0,1,3.86.54h23.21l.12-.11a2.93,2.93,0,0,1,3.42-.8,6.4,6.4,0,0,0,3.34.33c2.64-.35,5.29-.67,7.94-.87Z"
      />
      <path class="porch-5" d="M921.9,484.23s5,4,0,9C921.9,493.27,916.81,489.45,921.9,484.23Z" />
      <path class="porch-5" d="M921.9,496s5,4,0,9C921.9,505,916.81,501.19,921.9,496Z" />
      <path
        class="porch-5"
        d="M932,494.66s-3.87,5.08-8.83,0C923.19,494.66,926.93,489.44,932,494.66Z"
      />
      <path
        class="porch-5"
        d="M920.55,494.66s-3.87,5.08-8.83,0C911.72,494.66,915.46,489.44,920.55,494.66Z"
      />
      <path
        class="porch-3"
        d="M929.07,487.3s.77,6.39-6.25,6.39C922.82,493.69,921.86,487.3,929.07,487.3Z"
      />
      <path class="porch-3" d="M921,495.6s.77,6.4-6.24,6.4C914.72,502,913.76,495.6,921,495.6Z" />
      <path class="porch-3" d="M929,502s-6.24.79-6.24-6.4C922.78,495.6,929,494.62,929,502Z" />
      <path
        class="porch-3"
        d="M920.92,493.69s-6.25.79-6.25-6.39C914.67,487.3,920.92,486.31,920.92,493.69Z"
      />
      <ellipse class="porch-8" cx="921.87" cy="494.7" rx="2.65" ry="2.71" />
      <path
        class="porch-5"
        d="M802.81,496.52s5.29,1.3,3.16,7.11C806,503.63,800.63,502.49,802.81,496.52Z"
      />
      <path
        class="porch-5"
        d="M806.91,505.76s5.28,1.3,3.16,7.11C810.07,512.87,804.73,511.73,806.91,505.76Z"
      />
      <path
        class="porch-5"
        d="M814.41,501s-1.27,5.42-6.95,3.24C807.46,504.25,808.58,498.78,814.41,501Z"
      />
      <path
        class="porch-5"
        d="M805.39,505.21s-1.27,5.42-6.94,3.24C798.45,508.45,799.56,503,805.39,505.21Z"
      />
      <path
        class="porch-3"
        d="M809.52,496.31s2.84,4.74-2.68,7.31C806.84,503.62,803.85,499,809.52,496.31Z"
      />
      <path
        class="porch-3"
        d="M806,505.81s2.84,4.75-2.68,7.32C803.36,513.13,800.38,508.45,806,505.81Z"
      />
      <path
        class="porch-3"
        d="M814.62,507.89s-4.64,2.9-7.15-2.75C807.47,505.14,812,502.08,814.62,507.89Z"
      />
      <path
        class="porch-3"
        d="M805.34,504.32s-4.63,2.91-7.14-2.74C798.2,501.58,802.77,498.52,805.34,504.32Z"
      />
      <ellipse class="porch-8" cx="806.44" cy="504.77" rx="2.29" ry="2.34" />
      <path
        class="porch-5"
        d="M983.6,501.56s4.85,1.19,2.9,6.52C986.5,508.08,981.6,507,983.6,501.56Z"
      />
      <path
        class="porch-5"
        d="M987.36,510s4.85,1.2,2.9,6.53C990.26,516.56,985.36,515.51,987.36,510Z"
      />
      <path
        class="porch-5"
        d="M994.24,505.68s-1.16,5-6.37,3C987.87,508.65,988.9,503.63,994.24,505.68Z"
      />
      <path class="porch-5" d="M986,509.53s-1.17,5-6.37,3C979.6,512.5,980.62,507.48,986,509.53Z" />
      <path
        class="porch-3"
        d="M989.76,501.36s2.6,4.36-2.46,6.71C987.3,508.07,984.56,503.78,989.76,501.36Z"
      />
      <path
        class="porch-3"
        d="M986.57,510.08s2.6,4.36-2.46,6.71C984.11,516.79,981.37,512.5,986.57,510.08Z"
      />
      <path
        class="porch-3"
        d="M994.43,512s-4.25,2.67-6.55-2.51C987.88,509.47,992.07,506.66,994.43,512Z"
      />
      <path
        class="porch-3"
        d="M985.92,508.71s-4.25,2.67-6.55-2.51C979.37,506.2,983.56,503.39,985.92,508.71Z"
      />
      <ellipse class="porch-8" cx="986.94" cy="509.13" rx="2.1" ry="2.15" />
      <path
        class="porch-5"
        d="M896,521.19s4.85,1.2,2.9,6.53C898.93,527.72,894,526.67,896,521.19Z"
      />
      <path
        class="porch-5"
        d="M899.79,529.67s4.85,1.19,2.9,6.53C902.69,536.2,897.79,535.15,899.79,529.67Z"
      />
      <path
        class="porch-5"
        d="M906.67,525.32s-1.17,5-6.37,3C900.3,528.28,901.32,523.26,906.67,525.32Z"
      />
      <path
        class="porch-5"
        d="M898.39,529.17s-1.16,5-6.37,3C892,532.14,893.05,527.12,898.39,529.17Z"
      />
      <path
        class="porch-3"
        d="M902.18,521s2.61,4.35-2.45,6.71C899.73,527.71,897,523.42,902.18,521Z"
      />
      <path
        class="porch-3"
        d="M899,529.72s2.61,4.35-2.46,6.71C896.53,536.43,893.79,532.14,899,529.72Z"
      />
      <path
        class="porch-3"
        d="M906.86,531.62s-4.25,2.67-6.55-2.52C900.31,529.1,904.5,526.3,906.86,531.62Z"
      />
      <path
        class="porch-3"
        d="M898.35,528.35s-4.25,2.67-6.55-2.52C891.8,525.83,896,523,898.35,528.35Z"
      />
      <ellipse class="porch-8" cx="899.36" cy="528.76" rx="2.1" ry="2.15" />
      <path
        class="porch-5"
        d="M938.05,507.8s3.5.86,2.09,4.71C940.14,512.51,936.61,511.75,938.05,507.8Z"
      />
      <path
        class="porch-5"
        d="M940.77,513.92s3.5.86,2.09,4.71C942.86,518.63,939.32,517.87,940.77,513.92Z"
      />
      <path
        class="porch-5"
        d="M945.73,510.77a3.17,3.17,0,0,1-4.6,2.14S941.87,509.29,945.73,510.77Z"
      />
      <path
        class="porch-5"
        d="M939.76,513.55a3.18,3.18,0,0,1-4.6,2.15S935.9,512.07,939.76,513.55Z"
      />
      <path
        class="porch-3"
        d="M942.49,507.65a3.3,3.3,0,0,1-1.77,4.85S938.74,509.4,942.49,507.65Z"
      />
      <path class="porch-3" d="M940.19,514a3.29,3.29,0,0,1-1.77,4.84S936.44,515.7,940.19,514Z" />
      <path
        class="porch-3"
        d="M945.87,515.32s-3.07,1.93-4.73-1.81C941.14,513.51,944.16,511.48,945.87,515.32Z"
      />
      <path
        class="porch-3"
        d="M939.73,513s-3.07,1.93-4.73-1.81C935,511.15,938,509.12,939.73,513Z"
      />
      <ellipse class="porch-8" cx="940.46" cy="513.26" rx="1.51" ry="1.55" />
      <path
        class="porch-5"
        d="M968.81,528.19s2.85.7,1.7,3.84C970.51,532,967.63,531.41,968.81,528.19Z"
      />
      <path class="porch-5" d="M971,533.17s2.85.7,1.7,3.84C972.72,537,969.84,536.39,971,533.17Z" />
      <path
        class="porch-5"
        d="M975.06,530.62a2.58,2.58,0,0,1-3.74,1.74S971.92,529.41,975.06,530.62Z"
      />
      <path
        class="porch-5"
        d="M970.2,532.88a2.58,2.58,0,0,1-3.74,1.74S967.06,531.67,970.2,532.88Z"
      />
      <path
        class="porch-3"
        d="M972.42,528.08A2.68,2.68,0,0,1,971,532S969.37,529.5,972.42,528.08Z"
      />
      <path
        class="porch-3"
        d="M970.55,533.2a2.68,2.68,0,0,1-1.44,3.94S967.5,534.62,970.55,533.2Z"
      />
      <path
        class="porch-3"
        d="M975.17,534.32s-2.5,1.57-3.85-1.48C971.32,532.84,973.78,531.19,975.17,534.32Z"
      />
      <path
        class="porch-3"
        d="M970.17,532.4s-2.49,1.57-3.85-1.48C966.32,530.92,968.79,529.27,970.17,532.4Z"
      />
      <ellipse class="porch-8" cx="970.77" cy="532.64" rx="1.23" ry="1.26" />
      <path
        class="porch-5"
        d="M824.38,528.19s2.85.7,1.7,3.84C826.08,532,823.21,531.41,824.38,528.19Z"
      />
      <path
        class="porch-5"
        d="M826.59,533.17s2.85.7,1.7,3.84C828.29,537,825.42,536.39,826.59,533.17Z"
      />
      <path
        class="porch-5"
        d="M830.63,530.62a2.58,2.58,0,0,1-3.74,1.74S827.49,529.41,830.63,530.62Z"
      />
      <path
        class="porch-5"
        d="M825.77,532.88a2.58,2.58,0,0,1-3.74,1.74S822.63,531.67,825.77,532.88Z"
      />
      <path class="porch-3" d="M828,528.08a2.68,2.68,0,0,1-1.45,3.94S824.94,529.5,828,528.08Z" />
      <path
        class="porch-3"
        d="M826.12,533.2a2.68,2.68,0,0,1-1.44,3.94S823.07,534.62,826.12,533.2Z"
      />
      <path
        class="porch-3"
        d="M830.74,534.32s-2.49,1.57-3.84-1.48C826.9,532.84,829.36,531.19,830.74,534.32Z"
      />
      <path
        class="porch-3"
        d="M825.75,532.4s-2.5,1.57-3.85-1.48C821.9,530.92,824.36,529.27,825.75,532.4Z"
      />
      <ellipse class="porch-8" cx="826.34" cy="532.64" rx="1.23" ry="1.26" />
      <path
        class="porch-5"
        d="M868,484.33s2.85.7,1.71,3.84C869.71,488.17,866.83,487.55,868,484.33Z"
      />
      <path
        class="porch-5"
        d="M870.21,489.31s2.85.7,1.7,3.84C871.91,493.15,869,492.53,870.21,489.31Z"
      />
      <path
        class="porch-5"
        d="M874.25,486.76a2.58,2.58,0,0,1-3.74,1.74S871.11,485.55,874.25,486.76Z"
      />
      <path class="porch-5" d="M869.39,489a2.58,2.58,0,0,1-3.74,1.74S866.25,487.81,869.39,489Z" />
      <path
        class="porch-3"
        d="M871.62,484.22a2.68,2.68,0,0,1-1.44,3.94S868.57,485.64,871.62,484.22Z"
      />
      <path
        class="porch-3"
        d="M869.74,489.34a2.68,2.68,0,0,1-1.44,3.94S866.69,490.76,869.74,489.34Z"
      />
      <path
        class="porch-3"
        d="M874.37,490.46s-2.5,1.57-3.85-1.48C870.52,489,873,487.33,874.37,490.46Z"
      />
      <path
        class="porch-3"
        d="M869.37,488.54s-2.5,1.57-3.85-1.48C865.52,487.06,868,485.41,869.37,488.54Z"
      />
      <ellipse class="porch-8" cx="869.96" cy="488.78" rx="1.23" ry="1.26" />
      <path
        class="porch-5"
        d="M856.55,507.8s3.5.86,2.09,4.71C858.64,512.51,855.11,511.75,856.55,507.8Z"
      />
      <path
        class="porch-5"
        d="M859.27,513.92s3.5.86,2.09,4.71C861.36,518.63,857.82,517.87,859.27,513.92Z"
      />
      <path
        class="porch-5"
        d="M864.23,510.77a3.17,3.17,0,0,1-4.59,2.14S860.38,509.29,864.23,510.77Z"
      />
      <path
        class="porch-5"
        d="M858.26,513.55a3.18,3.18,0,0,1-4.6,2.15S854.4,512.07,858.26,513.55Z"
      />
      <path class="porch-3" d="M861,507.65a3.3,3.3,0,0,1-1.78,4.85S857.24,509.4,861,507.65Z" />
      <path class="porch-3" d="M858.69,514a3.29,3.29,0,0,1-1.77,4.84S854.94,515.7,858.69,514Z" />
      <path
        class="porch-3"
        d="M864.37,515.32s-3.07,1.93-4.73-1.81C859.64,513.51,862.67,511.48,864.37,515.32Z"
      />
      <path
        class="porch-3"
        d="M858.23,513s-3.07,1.93-4.73-1.81C853.5,511.15,856.52,509.12,858.23,513Z"
      />
      <ellipse class="porch-8" cx="858.96" cy="513.26" rx="1.51" ry="1.55" />
      <rect class="porch-8" x="254.99" y="433.65" width="484.93" height="39.28" />
      <rect class="porch-8" x="246.22" y="427.58" width="502.46" height="6.07" />
      <rect class="porch-5" x="254.99" y="433.65" width="484.93" height="5.18" />
      <rect class="porch-8" x="246.22" y="480.22" width="502.46" height="39.28" />
      <rect class="porch-8" x="237.46" y="474.15" width="520" height="6.07" />
      <rect class="porch-3" x="254.99" y="473.02" width="484.93" height="1.14" />
      <rect class="porch-5" x="246.22" y="480.22" width="502.46" height="5.18" />
      <rect class="porch-8" x="237.46" y="526.79" width="520" height="39.28" />
      <rect class="porch-8" x="228.69" y="520.72" width="537.53" height="6.07" />
      <rect class="porch-3" x="246.22" y="519.58" width="502.46" height="1.14" />
      <rect class="porch-5" x="237.46" y="526.79" width="520" height="5.18" />
      <path
        class="porch-9"
        d="M619.46,549.07l-.9,0,.1.11-.9-1.83.09.12c.22-.92.74-1.17,1.23-.3a5.51,5.51,0,0,1,.28,1.95Z"
      />
      <path class="porch-9" d="M403,353.14a6.51,6.51,0,0,1,.51-.54s.2.06.3.1l-.9.34Z" />
      <path class="porch-9" d="M403.86,495.31H403l-.07.11h1Z" />
      <path class="porch-9" d="M619.36,549.17l.32.14-.22-.24Z" />
      <path class="porch-9" d="M562.92,339.91l.81.87.07-.12h-1l.13.1c0-.31,0-.63,0-.95Z" />
      <path class="porch-9" d="M562.08,339.94l.84,0,0-.09H562Z" />
      <polygon class="porch-9" points="484.51 589.68 484.68 589.8 484.6 589.58 484.51 589.68" />
      <rect class="porch-3" y="377.32" width="1024" height="50.26" />
      <path
        class="porch-9"
        d="M563.73,340.78c1.86,1.09,3.71,2.2,5.56,3.29,2.32,1.35,4.46,3,7.26,3.41a6.42,6.42,0,0,1,2.75,1.62,93.73,93.73,0,0,1,7.81,6.5c3.78,3.74,7.24,7.78,8.26,13.36.69,3.78,1.44,7.55,2.15,11.33.26,1.35.45,2.71.72,4.06q1.28,6.47,2.6,12.91c.76,3.63,1.51,7.27,2.41,10.87a21.27,21.27,0,0,0,3.29,7.47,27.26,27.26,0,0,1,2.64,5.09c4.15,9.59,7,19.62,9.64,29.73a71.09,71.09,0,0,1,1.27,7.31c.2,1.35,0,1.8-1.38,1.86-1.7.08-2.3,1-2.7,2.48-1.56,5.63-5.81,9.21-9.88,12.73-2,1.7-4.77,2.47-7.27,3.43-4.28,1.65-8.63,3.06-13.34,2.3a20.87,20.87,0,0,0-4,0c-.67,0-1,.34-.51,1a26.22,26.22,0,0,0,2.32,3.32,72.46,72.46,0,0,1,12.51,17.61c2.41,4.74,5.52,9.11,8.29,13.66a42,42,0,0,1,2.19,3.94Q611.48,531,616.59,542c.48,1,1.45,2.1-.06,3.09l1.32,2.4-.09-.12.9,1.83-.1-.11a51.55,51.55,0,0,0,4.61,11.75,15.27,15.27,0,0,1,1.91,7.07,3.8,3.8,0,0,1-1.13,2.89,13.42,13.42,0,0,1-6.2,4.31,22,22,0,0,0-5.93,3.4,30.11,30.11,0,0,1-7.28,4.27,56.83,56.83,0,0,0-5.5,2.53c-2.88,1.4-5.77,1-8.63,0A2.75,2.75,0,0,1,589,584a1.54,1.54,0,0,1,.24-1.43c.71-.61,1.66-.91,2.39-1.49s.72-.93-.43-1-.34-.72,0-1c3.31-2.87,5.82-6.45,8.49-9.89a9.12,9.12,0,0,0,1.44-2.46,2.22,2.22,0,0,0-.19-1.89c-1.87-1.87-2.63-4.42-4-6.57-3.23-4.94-6.72-9.58-11.37-13.26-1.78-1.41-3.11-3.4-4.72-5.06a34.86,34.86,0,0,0-3-2.66c-.13-.11-.53,0-.7.13s-.36.53-.29.7c.52,1.26,1.13,2.48,1.66,3.73a22,22,0,0,1,1.27,3.45,5.18,5.18,0,0,1-.19,2.43c-.7,2.37-.7,2.31.82,3.59,2,1.66,3.91,3.35,5.74,5.17a6.91,6.91,0,0,1,1.62,2.77c1,3.07.3,4.1-2.56,5.38a67.38,67.38,0,0,0-6.79,3.55,22.23,22.23,0,0,1-5.34,2.73,9,9,0,0,0-4.18,3c-2.23,2.8-5.13,3.82-8.41,4.22a6.51,6.51,0,0,0-.43-.6s-.21.07-.31.11l.83.38c-3.25,1.43-6.58,1-9.85.24-2-.48-2.29-2.37-.87-3.82.47-.47,1.09-.79,1.59-1.24,2.4-2.19,4.82-4.36,7.15-6.64a12.78,12.78,0,0,0,1.82-2.7,4.22,4.22,0,0,0-.24-5.33,12.15,12.15,0,0,1-1.43-2c-4.07-7.91-10.63-13.38-17.31-18.75a45.46,45.46,0,0,1-4.82-4.38,9.74,9.74,0,0,1-2.41-3.73c-.76-2.83-2.54-4.8-4.44-6.76a16.37,16.37,0,0,0-1.48-1.41c-6.34-5-10.93-11.69-15.61-18.22-4.4-6.13-7.32-13.14-10.22-20.11a96.81,96.81,0,0,1-6-20.51,45.39,45.39,0,0,1-.46-11.52,16.78,16.78,0,0,1,3.77-9c.49-.65,1.15-1.17,1.64-1.82.3-.4.66-1,.56-1.39a1.6,1.6,0,0,0-1.21-.78,19.91,19.91,0,0,0-7.16.3,18.1,18.1,0,0,1-9.19.12,10.34,10.34,0,0,0-6.32.37,1.65,1.65,0,0,0-.81,2.66c2.32,3.2,4.72,6.35,7.09,9.52a1.83,1.83,0,0,0,.56.58c4.2,2.08,5.82,6.38,8,10.07A41.73,41.73,0,0,1,498.55,478a32.82,32.82,0,0,1-.57,10.66,28.56,28.56,0,0,0-.71,7.36,3.39,3.39,0,0,1-1.62,3.5c-1.64,1-2.19,2.73-2.88,4.37a155.32,155.32,0,0,0-6.85,19.83c-1.9,7.21-4.84,14-7.71,20.83a50.21,50.21,0,0,0-3.4,11.83C474,562,473,567.54,472.07,573.1c-.07.41-.19.8-.24,1.21-.45,3.52-.16,4,3.18,5.54l-1,.28.95.32,0,.22-.12-.13a3.05,3.05,0,0,1,0-.8,21.67,21.67,0,0,1,9.61,9.94l.09-.1a.85.85,0,0,0-.18,1.37c.43.5,1.17,1,1.18,1.54a4.4,4.4,0,0,1-.71,2.7,21.22,21.22,0,0,0-2.19,3.38,3.21,3.21,0,0,1-2.26,1.4c-4.32.28-8.48,0-12.47-2.35a75.85,75.85,0,0,1-12.82-9.26c-.8-.73-1.59-1.49-2.33-2.28-2.41-2.54-3.54-5.45-2.51-9a12.68,12.68,0,0,0,.53-3.67c-.1-6.66,1.25-13.14,2.5-19.61a270.68,270.68,0,0,0,3.82-29.48c.35-4.25.51-8.52.72-12.78a21.42,21.42,0,0,0-.06-2.89c-.11-1.2-.87-1.81-1.92-1.45a58.64,58.64,0,0,0-6,2.3,4.34,4.34,0,0,0-1.85,2,38.15,38.15,0,0,0-1.88,5c-2.84,9.11-7.11,17.54-11.58,25.87-3.43,6.39-6.94,12.74-10.23,19.2-2.24,4.39-4.19,8.94-6.21,13.45a10.35,10.35,0,0,0-.47,2.33l-.79.8-.26.14.16-.24.81-.79c1.56-.23,2-1.62,2.74-2.75a13.76,13.76,0,0,1,.95-1.19,5.63,5.63,0,0,1-.39,1.85,31.27,31.27,0,0,1-2.69,3.58c-3.06,3.48-6.17,6.9-9.26,10.35a4.33,4.33,0,0,0-.78.95c-1.44,3.42-4.32,3.75-7.4,3.66-1.48,0-3-.21-4.43-.17a3.13,3.13,0,0,1-2.95-1.77c-1.06-1.77-.88-3.69-.58-5.61a1.41,1.41,0,0,1,.41-.65c3.61-3.82,3.94-4.45,5-9.67a3.63,3.63,0,0,1,.43-1c3.86-6.4,6-13.51,7.81-20.7a95.33,95.33,0,0,0,2.59-17.52c.26-4.21,1.53-8.36,2.45-12.52,1.37-6.17,2.88-12.31,4.22-18.49.59-2.71.28-3.55-2-4.73-3.33-1.77-6.6-3.66-9.9-5.5l.07.11h-1l.07-.11a5.45,5.45,0,0,1-3.53-2.57,7.65,7.65,0,0,0-3-2.57c-2.45-1.44-4.8-3-7.21-4.51-1.81-1.12-3.35-2.57-5.43-3.41-1.74-.7-3.11-2.56-4.44-4.08-1.88-2.14-3.62-4.42-5.34-6.7a12,12,0,0,1-1.28-2.56,17,17,0,0,0-1.36-3.43c-1.59-2.17-1.62-4.6-1.53-7.09a39.35,39.35,0,0,1,2.81-13.68c2.34-5.7,4.9-11.31,7.62-16.83a40.49,40.49,0,0,0,4.22-16.6c.37-9.48,1-19,3.27-28.24a10.93,10.93,0,0,1,1.69-3.63,39.51,39.51,0,0,0,3.07-6.22c.49-1.09,1.14-2.36-.74-2.87-1.45-2.14-2-4.1-.12-5.85a29.32,29.32,0,0,0,3.5-4.49,19.9,19.9,0,0,1,7.84-6.84l-.09-.1c-.21,1.72.15,2.19,1.36,1.64,3-1.36,6.07-2.79,9.1-4.21a19.68,19.68,0,0,1,5.4-1.38c2.88-.47,5.71-1.28,8.56-1.94l0,.31-.12-.21a3.16,3.16,0,0,0-2.61-1.7,2.8,2.8,0,0,1-2.38-1.94,12.7,12.7,0,0,0-1.31-2.54c-3.22-4.5-2.78-9.09,0-13.49s5.52-8.49,8.61-12.48c1.55-2,3.74-3.55,6.63-3.23a22.91,22.91,0,0,0,3.61,0,47.33,47.33,0,0,0,5.6-.45,9,9,0,0,1,7.85,2c1.78,1.45,3.65,2.64,5,4.65a6,6,0,0,1,1.21,3.4,40.12,40.12,0,0,1-.23,6.59,11.64,11.64,0,0,0,.25,5.66c.12.39.12.83.25,1.21,2.22,6.1.48,11.57-2.49,16.86-.14.24-.3.46-.42.7a1.56,1.56,0,0,0,1.2,2.42c2.66.36,5.33.6,8,.89,1.33.15,2.67.25,4,.46s2.38.51,3.34-.67a1.61,1.61,0,0,1,1.05-.45,29.5,29.5,0,0,0,11.4-3.75,14.67,14.67,0,0,1,2.25-.9l25-8a7.72,7.72,0,0,0,1.16-.34c2.92-1.46,5.89-2.48,9.19-1.35.18.06.53-.35.8-.54a6.11,6.11,0,0,0-.65-.38c-.24-.1-.5-.16-.75-.25.18-.1.34-.28.53-.31,1-.17,1.35-.76,1-1.74-.63-1.82-1.15-3.7-3.17-4.53-.37-.15-.46-2.75-.14-3.08a8.7,8.7,0,0,1,.92-.79,12.59,12.59,0,0,0,4.66-7.94c.37-2.06,1.17-4-1-5.53a1.62,1.62,0,0,1-.2-1.49,23.32,23.32,0,0,1,2.92-5.37,50.49,50.49,0,0,1,6.29-5.75,9.85,9.85,0,0,1,6.81-2c2.12.08,4.25-.46,6.38-.53a21.71,21.71,0,0,1,5.16.3,12.9,12.9,0,0,1,6.09,3.08c1.31,1.2,2.7,1.81,4.4,1.24,1.49-.49,2.95-.63,4.21.43a7.17,7.17,0,0,1,2.47,5,6.39,6.39,0,0,1-1.77,5.31c-1.68,1.58-2.32,3.6-3.1,5.66a51.65,51.65,0,0,1-5.76,11.33c-.47.67-1,1.32-1.41,2a1.54,1.54,0,0,0,.21,2.21c1.27,1,2.6,1.89,3.9,2.83l-.06-.11.92.94-.13-.1h1ZM433.72,541c-.07.23-.15.47-.23.7,0-.27.09-.54.13-.8l.21-.16Zm77.37-119.73a20.53,20.53,0,0,0,2.36.13,1.07,1.07,0,0,0,1-1.41,20,20,0,0,0-.68-2.37,160.2,160.2,0,0,1-4.88-19.11c-.55-2.82-1.18-5.64-1.9-8.42-.67-2.56-1.39-3.21-4-3.09a43.6,43.6,0,0,1-11.17-1,9.56,9.56,0,0,0-1.19-.21,1.1,1.1,0,0,0-1.19,1.57c1,2.71,2.09,5.36,3,8.1a124.81,124.81,0,0,1,4.85,19.95c.29,2,1.23,3.43,3.12,3.82C504.08,419.88,507.63,421.32,511.09,421.22Zm67.12,124.87L577,544.82c-.13.22-.34.43-.36.67-.09.91.38,1.59.91,1.38C577.78,546.79,577.9,546.49,578.21,546.09Z"
      />
    </g>
  </svg>
</template>

<script>
import { hexToHsl } from '@/services/utils'

export default {
  props: ['color'],
  computed: {
    cssVars() {
      return {
        '--color': hexToHsl(this.color),
      }
    },
  },
}
</script>

<style>
.porch-1 {
  fill: hsl(var(--color), 37%, 64%);
}

.porch-2 {
  fill: hsl(var(--color), 100%, 27%);
}

.porch-3 {
  fill: hsl(var(--color), 38%, 92%);
}

.porch-4 {
  fill: hsl(var(--color), 100%, 27%);
}

.porch-5 {
  fill: hsl(var(--color), 100%, 90%);
}

.porch-6 {
  fill: hsl(var(--color), 100%, 14%);
}

.porch-7 {
  fill: hsl(var(--color), 38%, 73%);
}

.porch-8 {
  fill: #fff;
}

.porch-9 {
  fill: hsl(var(--color), 100%, 7%);
}
</style>
